// 1. Imports
import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import NotificationImg from "./../../../assets/notification-img.png";
import { photosApi } from "../../../SourceData";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  selectedNotification,
  refreshData,
}) => {
  console.log(selectedNotification);
  const renderNotificationView = () => {
    // Check if we have a selectedNotification object
    if (!selectedNotification) {
      return (
        <div className="user-modal">
          <p className="user-modal-p">تفصيل الاشعار</p>
          <div className="notification-placeholder">
            لم يتم تحديد إشعار للعرض
          </div>
        </div>
      );
    }

    // Use the actual notification data
    const { title = { ar: "", en: "" }, text = { ar: "", en: "" } } =
      selectedNotification;

    return (
      <div className="user-modal">
        <p className="user-modal-p">تفصيل الاشعار</p>
        <img
          src={photosApi + selectedNotification?.photo}
          alt=""
          className="notification-img"
        />

        {/* Arabic content */}
        <span className="ar-name">{title.ar}</span>
        <p className="ar-desc">{text.ar}</p>

        {/* English content */}
        <span className="en-name">{title.en}</span>
        <p className="en-desc">{text.en}</p>

        {/* Display additional notification details if available */}
        {selectedNotification.createdAt && (
          <div className="notification-meta">
            <span className="meta-label">تاريخ الإنشاء:</span>
            <span className="meta-value">
              {new Date(selectedNotification.createdAt).toLocaleDateString(
                "ar-EG"
              )}
            </span>
          </div>
        )}

        {selectedNotification.senderType && (
          <div className="notification-meta">
            <span className="meta-label">نوع المستلم:</span>
            <span className="meta-value">
              {selectedNotification.senderType === "all"
                ? "الجميع"
                : selectedNotification.senderType === "User"
                ? "المستخدمين"
                : selectedNotification.senderType === "technician"
                ? "الفنيين"
                : "مخصص"}
            </span>
          </div>
        )}
      </div>
    );
  };

  const renderDefaultView = () => <div></div>;

  const views = {
    viewNotification: renderNotificationView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
